const multipleWhiteSpaceRegExp = /\s{2,}/g;
const specialCharRegExp = /[.*+?^${}()|[\]\\]/g;

function escapeRegExp(searchText: string): string {
    return searchText.replace(specialCharRegExp, '\\$&');
}

export function createSearchRegExp(searchText: string, flags?: string): RegExp | null {
    const normalizedSearchText = searchText.trimStart().replace(multipleWhiteSpaceRegExp, ' ');
    if (!normalizedSearchText) {
        return null;
    }

    let pattern = '\\b' + escapeRegExp(normalizedSearchText);
    if (pattern.endsWith(' ')) {
        // A trailing space matches either an actual space or the end of the string:
        pattern = pattern.slice(0, -1) + '(?: |$)';
    }
    return new RegExp(pattern, flags);
}
